import { defaults } from "lodash";
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react";
import { Helmet } from "react-helmet";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useIndicator from "@hooks/useIndicator";
import moment from "moment";
import { comma, dataUrlToFile } from "@util/helper";
import SignatureCanvas from "react-signature-canvas";
import MyDialog2 from "@components/MyDialog2";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { MAX_FILE_SIZE } from "@util/constant"
import { showSnackbar } from "@context/SnackbarContext";
import axios from "axios";
import useAlert from "@hooks/useAlert";
import { defaultGroupByFn } from "react-table";
import { createOrderNo } from "./common/common";
import WebService from "@util/webService";
import Footer from "@components/part/Footer";
import ConfirmDialog from '@components/ConfirmDialog'
import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
} from '@mui/material'
import { isAdmin } from "@util/helper";
import { LogoutOutlined, Person } from '@mui/icons-material'
import ArchitectureOutlined from '@mui/icons-material/ArchitectureOutlined'

const Contract2 = () => {
  const location = useLocation();
  const pack = location.state?.pack;
  const order = pack?.data?.order ?? {};

  const branch = pack?.data?.branch
  const branchAddr = branch
    ? [branch.addr1, branch.addr2].filter((s) => s?.trim()).join(' ')
    : '서울특별시 강서구 마곡서로 101, 824(마곡동, 동익드미라벨복합빌딩)'

  // 임대인 정보: 계약 지점(branches) 기준
  const lessor = {
    companyName: branch?.companyName ?? '',
    repName: branch?.repName ?? '',
    // 사업자번호: 분할 컬럼이 모두 있으면 3-2-5 형식, 아니면 biz_num 원본
    bizNum: branch?.bizNum1 && branch?.bizNum2 && branch?.bizNum3
      ? `${branch.bizNum1}-${branch.bizNum2}-${branch.bizNum3}`
      : branch?.bizNum ?? '',
    phone: branch ? [branch.phoneDial, branch.phone1, branch.phone2].filter((s) => s).join('-') : '',
    addr: branch ? [branch.addr1, branch.addr2].filter((s) => s?.trim()).join(' ') : '',
  }
  // 소유주 동의는 전대(소유주와 임대인이 다른 경우, subLeaseYn = 'Y') 지점 계약에만 표시
  const isSubLease = branch?.subLeaseYn === 'Y'
  const ownerName = branch?.ownerName ?? ''
  // 지점에 업로드된 인장 파일 (/public/info 지점 목록의 attchList)
  // 임대인 인장: cat_code = SP01
  const stampAttch1 = (branch?.attchList ?? []).find((a) => a.catCode === 'SP01')
  const stampUrl1 = stampAttch1 ? `/bis/repo/${stampAttch1.fileLoc}` : ''
  // 소유주 인장: cat_code = SP02
  const stampAttch2 = (branch?.attchList ?? []).find((a) => a.catCode === 'SP02')
  const stampUrl2 = stampAttch2 ? `/bis/repo/${stampAttch2.fileLoc}` : ''

  const navigate = useNavigate();
  const codes = useSelector((state) => state.codeReducer);
  const productCodes = codes.filter((r) => r.codeGroupId === "R001");
  const [isLoading, set_isLoading] = useState(true);
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator();
  const { alert, renderAlert } = useAlert()
  const sigRef = useRef(null);
  const [tmpFiles, set_tmpFiles] = useState([])
  const [imgUrl, set_imgUrl] = useState('')
  const dgRef = useRef();
  const xRef = useRef()
  const [modalVisible, set_modalvisible] = useState(false);
  const fileInputRef = useRef()
  const theme = useTheme()
  const [start, set_start] = useState({})
  const [end, set_end] = useState({})
  const fileNameRef = useRef('')
  const account = useSelector((state) => state.accountReducer)
  const [payInfo, set_payInfo] = useState({})

  const fetchPayInfo = async() => {
    const url = `/public/pay/info`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      showSnackbar('결제사정보를 가져올 수 없습니다.')
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const payInfo = JSON.parse(repMessage.payInfo)
    set_payInfo(payInfo)
  }

  useEffect(() => {

    if(!order.id) {
      closeIndicator()
      navigate('/')
    }
    else {
      const startTime = moment(order.startTime, "YYYY-MM-DD HH:mm:ss" )
      const endTime = moment(order.endTime, "YYYY-MM-DD HH:mm:ss" )
      const start = {
        year: startTime.year(),
        month: startTime.month() + 1,
        day: startTime.date(),
      };

      const end = {
        year: endTime.year(),
        month: endTime.month() + 1,
        day: endTime.date(),
      };
      set_start(start)
      set_end(end)

      fetchPayInfo()
    }

  }, [])



  const onChangeFile = (e) => {
    const files = Array.from(e.target.files)
		const file = files[0]
    if(file.size > MAX_FILE_SIZE) {
      showSnackbar('파일 크기는 3MB 이하만 가능합니다.', theme.palette.warning.dark)
      return
    }
		set_tmpFiles(files)
  }

  const payRequest = () => {
    // console.log('payInfo=>', payInfo)
    if(!payInfo.returnUrl) {
      showSnackbar('결제사 정보를 가져올 수 없습니다(2).')
      return
    }
    window.cookiepayments.payrequest({
        ORDERNO: order.orderNo, //주문번호 (필수)
        PRODUCTNAME: productCodes.find(r => r.code === order.productCode).name, //상품명 (필수)
        // AMOUNT: 500,
        AMOUNT: order.amount,
        BUYERNAME: order.repName, //고객명 (필수)
        // BUYEREMAIL: $("#BUYEREMAIL").val(), //고객 e-mail (선택)
        PAYMETHOD: 'CARD', //결제 수단 (선택)
        PRODUCTCODE: order.productCode, //상품 코드 (선택)
        // BUYERID: $("#BUYERID").val(), //고객 아이디 (선택)
        // BUYERADDRESS: $("#BUYERADDRESS").val(), //고객 주소 (선택)
        BUYERPHONE : order.repPhone, //고객 휴대폰번호 (선택, 웰컴페이는 필수)
        RETURNURL: payInfo.returnUrl,
        // RETURNURL: `https://sandbox.cookiepayments.com/payRec/pay_success`, //결제 완료 후 리다이렉트 url (필수)
    });
  }

  const prepareSubmit = async () => {
    if(!imgUrl) {
      showSnackbar('서명을 하여 주세요.', theme.palette.warning.dark)
      xRef.current.focus()
      return
    }

    const idFiles = pack?.data.idFiles
    if(!idFiles || idFiles.length == 0) {
      showSnackbar('대표자 신분증이 비어 있습니다.', theme.palette.warning.dark)
      return
    }
    return true
  };

  const onSubmit = async (adminMode) => {
    const ret = await prepareSubmit()
    if(!ret) {
      return
    }

    const bizFiles= pack?.data.bizFiles
    const corpFiles= pack?.data.corpFiles
    const agencyFiles= pack?.data.agencyFiles
    const sigFile = dataUrlToFile(
      imgUrl,
      fileNameRef.current
    )

    const params = {}
    const formData = new FormData()

    const idFiles = pack?.data.idFiles
    if(idFiles && idFiles.length > 0) {
      formData.append('idFiles', idFiles[0])
    }

    if(bizFiles && bizFiles.length > 0) {
      formData.append('bizFiles', bizFiles[0])
    }

    if(corpFiles && corpFiles.length > 0) {
      corpFiles.forEach(f => {
        formData.append('corpFiles', f)
      })
    }
    if(agencyFiles && agencyFiles.length > 0) {
      formData.append('agencyFiles', agencyFiles[0])
    }

    order.orderNo = createOrderNo()
    if(adminMode) {
      order.statCode = 'S001'
    }
    const data = {
      order: order
    }
    formData.append('sigFiles', sigFile)

    const jsonData = JSON.stringify(data)
    formData.append('body', new Blob([jsonData], { type: 'application/json' }))

    const url = `/public/order/create`
    const resp = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: params,
    })

    if (resp.data.repCode !== 'ack') {
      alert(resp.data.repMessage)
      return
    }
    else {
      if(adminMode) {
        showSnackbar('처리되었습니다.')
        navigate('/admin')
      }
      else {

        openIndicator()
        console.log('payRequest...')
        payRequest()
      }
      // showSnackbar('처리 되었있습니다.', )
    }
  };


  useEffect(() => {
    if (!payInfo.apiId) {
      return
    }
    // App.js 가 결제 스크립트를 async 로 붙이므로, 직접 접속 시 아직 로드 전일 수 있음
    let timer = null
    const tryInit = () => {
      if (window.cookiepayments) {
        window.cookiepayments.init({ api_id: payInfo.apiId })
      }
      else {
        timer = setTimeout(tryInit, 100)
      }
    }
    tryInit()
    return () => clearTimeout(timer)
  }, [payInfo])

  useEffect(() => {
    if (!order) {
      navigate("/contract2");
    }
  }, []);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      set_isLoading(false);
      closeIndicator();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return openIndicator();
  }

  const SignModal = () => {
    const [tabValue, set_tabValue] = useState(1);
    const handleTabChange = (e, newValue) => {
      set_tabValue(newValue);
    };

    return (
      <div id="sign_modal2">
        <TabContext value={tabValue}>
          <TabList
            onChange={handleTabChange}
            scrollButtons="auto"
            variant="scrollable"
          >
            <Tab label={"서명/인감 파일"} value={1} />
            <Tab label={"서명 그리기"} value={2} />
          </TabList>
          <TabPanel value={1}>
            <div className="tabs_content">
              <div className="tab_1">
                <label className="custom_file">
                  <sapn className="filename" >
                    {tmpFiles.length > 0 ? tmpFiles[0].name : ''}
                  </sapn>
                  <input
                    type="file"
                    className="visual-hidden"
                    name="file"
                    id="signImgInput"
                    accept=".jpg, .jpeg, .png"
                    onChange={(e) => {
                      set_tmpFiles([...e.target.files])
                    }}
                    ref={fileInputRef}
                  />
                  <button type="button" className="upload_btn"
                    onClick={(e) => {
                      fileInputRef.current.click()
                    }}
                  >
                    파일 선택
                  </button>
                </label>
                <span>*png, jpg 등 이미지 파일을 등록 가능 합니다.</span>
                <div className="btn_box">
                  <button
                    type="button"
                    id="imgUpBtn"
                    className="submit_btn btn"
                    onClick={(e) => {
                      if(tmpFiles.length=== 0) {
                        showSnackbar('파일을 선택해 주세요.', theme.palette.warning.dark)
                        return
                      }
                      const file = tmpFiles[0]
                      const reader = new FileReader()
                      reader.onload = () => {
                        set_imgUrl(reader.result)
                      }
                      reader.readAsDataURL(file)
                      dgRef.current.close()
                      set_tmpFiles([])
                      fileNameRef.current = 'sig_picture.png'
                    }}
                  >
                    서명 사용
                  </button>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel value={2} style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
            <SignatureCanvas
              clearOnResize={false}
              ref={sigRef}
              canvasProps={{
                style: {
                  display:'flex',
                  alignItems:'center',
                  backgroundColor: "#fafafa",
                  border: "1px solid silver",
                  width: 400,
                  height: 150,
                  marginBottom:25,
                },
              }}
            />
            <div className="btn_box">
              <button
                type="button"
                className="cancle_btn btn"
                id="drawSignCan"
                onClick={() => {
                  sigRef.current.clear()
                }}
              >
                초기화
              </button>
              <button
                type="button"
                id="imgUpBtn"
                className="submit_btn btn"
                onClick={(e) => {
                  if(sigRef.current.isEmpty()) {
                    showSnackbar('서명란에 사인해 주세요.', theme.palette.warning.dark)
                    return
                  }
                  const url = sigRef.current.getTrimmedCanvas().toDataURL('image/png')
                  set_imgUrl(url)
                  fileNameRef.current = 'sig_draw.png'
                  dgRef.current.close()
                }}
              >
                서명 사용
              </button>
            </div>

          </TabPanel>
        </TabContext>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <script src="/src/js/main.js?v=1.0.0"></script>
      </Helmet>
      <MyDialog2
        title={"서명하기"}
        ref={dgRef}
        component={<SignModal />}
        windowWidth="sm"
      />
      <div id="root" />
      <header id="header">
        <div className="container">
          <div className="logo">
            <a href="/">
              <img
                src="/src/img/logo_w.svg"
                alt="비상주 오피스"
                className="white"
              />
              <img
                src="/src/img/logo.svg"
                alt="비상주 오피스"
                className="black"
              />
            </a>
          </div>
          <div className="gnb">
            <nav className="gnb_nav">
              <ul>
                <li>
                  <a href="#">비상주 오피스</a>
                  <div className="dropdown">
                    <a href="/home#about">비상주오피스 소개</a>
                    <a href="/home#progress">계약절차안내</a>
                    <a href="/home#contact">계약,결제하기</a>
                  </div>
                </li>
                <li>
                  <a href="/home#bundle">결합 할인 서비스</a>
                </li>
                <li>
                  <a href="/home#location">오시는 길</a>
                </li>
              </ul>
            </nav>
            <div className="inquiry">
              <a href="/home#contact">빠른 계약하기</a>
            </div>
            {
              account?.user?.id ? (
                <>
                  {
                    isAdmin(account) ? (
                      <div>
                        <IconButton onClick={() => navigate('/admin')}>
                          <ArchitectureOutlined style={{color:'#9e9e9e'}}/>
                        </IconButton>
                      </div>
                    ) : null
                  }
                  <div>
                    <IconButton onClick={() => navigate('/logout')}>
                      <LogoutOutlined style={{color:'#9e9e9e'}}/>
                    </IconButton>
                  </div>
                </>

              ) : null
            }
          </div>
          <div className="mo_btn">
            <a href="#" id="moBtn">
              <img src="/src/img/nav_on_w.svg" className="white" />
              <img src="/src/img/nav_on_b.svg" className="black" />
            </a>
          </div>
        </div>
        <div className="side_menu">
          <div className="box">
            <div className="logo">
              <a href="/">
                <img src="/src/img/logo_w.svg" alt="비상주 오피스" />
              </a>
            </div>
            <nav className="side_nav">
              <ul>
                <li>
                  <a href="#">비상주 오피스</a>
                  <div className="dropdown">
                    <a href="/home#about">비상주오피스 소개</a>
                    <a href="/home#progress">계약절차안내</a>
                    <a href="/home#contact">계약,결제하기</a>
                  </div>
                </li>
                <li>
                  <a href="/home#bundle">결합 할인 서비스</a>
                </li>
                <li>
                  <a href="/home#location">오시는 길</a>
                </li>
              </ul>
            </nav>
            <div className="inquiry">
              <a href="/home#contact">빠른 계약하기</a>
            </div>
            <a href="#" id="moCan">
              <img src="/src/img/nav_can.svg" />
            </a>
          </div>
        </div>
      </header>
      <div className="sub_banner step_3">
        <div className="container">
          <div className="text_box">
            <h2
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              빠르고 합리적으로 계약을 도와드립니다.
            </h2>
          </div>
        </div>
      </div>
      <div className="contract_cont">
        <div className="container">
          <div className="title">
            <span
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              Lease Agreement
            </span>
            <h2
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={200}
            >
              비지니스센터 이용 계약서
            </h2>
            <p data-aos="fade-up" data-aos-duration={1500} data-aos-delay={300}>
              계약서를 작성하시면 계약이 완료 됩니다.
            </p>
          </div>
          <div
            className="cont_box"
            data-aos="fade-up"
            data-aos-duration={1500}
            data-aos-delay={400}
          >
            <form>
              <div className="top_info">
                <h2>부동산의 표시</h2>
                <div className="table_box">
                  <table>
                    <colgroup>
                      <col width="25%" />
                      <col width="25%" />
                      <col width="25%" />
                      <col width="25%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">소재지</th>
                        <td colSpan={4}>
                          {branchAddr}, 호실은 결제 완료 시 확정
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" rowSpan={2}>
                          사무실 임대
                        </th>
                        <td>
                          <span>1</span> 인실
                        </td>
                        <th scope="row">사무실 호실</th>
                        <td>미정</td>
                      </tr>
                      <tr>
                        <td>1.2m²</td>
                        <th scope="row">사용인원</th>
                        <td>1명</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="content">
                <h2>계약내용</h2>
                <dl>
                  <dt>제1조 [보증금과 지급시기]</dt>
                  <dd>
                    임대인과 임차인은 위 임대차 부동산에 관하여 보증금과
                    임대료에 대해 아래와 같이 합의한다.
                  </dd>
                </dl>
                <div className="table_box">
                  <table>
                    <colgroup>
                      <col width="33.3%" />
                      <col width="33.3%" />
                      <col width="33.3%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">계약기간</th>
                        <th>시작일</th>
                        <th>종료일</th>
                      </tr>
                      <tr>
                        <td scope="row" className="td_center">
                          <span>{order.month}</span>개월
                        </td>
                        <td className="td_center">
                          <span>{start.year}</span>년 <span>{start.month}</span>
                          월 <span>{start.day}</span>일
                        </td>
                        <td className="td_center">
                          <span>{end.year}</span>년 <span>{end.month}</span>월{" "}
                          <span>{end.day}</span>일
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table>
                    <colgroup>
                      <col width="25%" />
                      <col width="25%" />
                      <col width="25%" />
                      <col width="25%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th scope="row">사용료(월)</th>
                        <td>
                          <span>{comma(order.mAmount)}</span>원
                        </td>
                        <th scope="row">선납할인적용</th>
                        <td>
                          <span>적용</span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">우편물발송서비스</th>
                        {/* 우편물 실물 발송 서비스는 종료되어 제외, 남은 칸까지 차지 */}
                        <td colSpan={3}>
                          <span>
                            {order.emailSvcYn === "Y" ? "신청" : "미신청"}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">사용료(합계)</th>
                        <td>
                          <span>{comma(order.amount)}</span>원
                        </td>
                        <th scope="row">예치금</th>
                        <td>
                          <span>없음</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <dl>
                  <dt>제2조 [계약기간]</dt>
                  <dd>
                    <span>①</span> 임대차 기간은 [부동산의 표시 및 계약내용]의
                    계약기간 까지로 한다.
                  </dd>
                  <dd>
                    <span>②</span> 임차인은 임차인에게 제공된 비지니스센터 이용
                    계약서에 기재된 소재지 호실과 동일하게 사용되어야 한다.
                  </dd>
                </dl>
                <dl>
                  <dt>제3조 [용도변경 및 전대 ,불법행위 금지]</dt>
                  <dd>
                    <span>①</span> 임차인은 임대인의 동의 없이는 위 부동산의
                    용도나 구조 등을 변경하거나 전대,임차권 양도 또는 담보제공을
                    하지 못하며 임대차 목적 이외의 용도에 사용할 수 없다.
                  </dd>
                  <dd>
                    <span>②</span> 임차인이 도박, 사기등 불법행위나 위법행위를
                    할경우 임대인은 제4조에 따라 계약을 해지 할수있다.
                  </dd>
                </dl>
                <dl>
                  <dt>제4조 [계약의 해지]</dt>
                  <dd>
                    <span>①</span> 임차인이 1회 이상 차임의 지급을 연체하거나
                    제3조를 위반했을 때는 임대인은 본 계약을 해지할 수 있다.
                  </dd>
                  <dd>
                    <span>②</span> 임차인은 최초 선납기간 종료 이전에
                    제3조에따른 사유외 중도해지시 임차인은 30일이전에 통보하며
                    정상가격 (월 100,000원, vat별도)을 사용한 기간만큼 월할
                    정산후 반환한다. 제3조에따른 계약해지시 잔여 임대료는
                    위약금으로 대체되어 반환되지 아니한다.
                  </dd>
                  <dd>
                    <span>③</span> 임대차 계약만료후 연장을 안하고 무단
                    전출하거나 또는 사실상 사업을 폐업한경우 관할세무서에
                    이전또는 폐업 신고를 하며 그렇지 않을경우 관할세무서로 부터
                    직권폐업될 수 있음에 동의 하며, 이에따른 일체 이의를
                    제기하지 않는다. 자진 미신고시 임대인은 관할세무서에
                    직권폐업을 요청할수있으며, 해당 요청에 동의하며 이에 일체
                    이의를 제기하지 않는다.
                  </dd>
                </dl>
                <dl>
                  <dt>제5조 [계약의 종료] </dt>
                  <dd>
                    <span>①</span> 임대차 계약이 종료된 경우 임차인은 위
                    부동산을 원상으로 회복하여 임대인에게 반환한다.
                  </dd>
                  <dd>
                    <span>②</span> 임차인이 차임의 지급을 미루거나 지급이 안되어
                    계약이 해지되면 관할 세무서에 통지될 수 있으며 이로인해
                    발생된 불이익의 책임은 임차인에게 있다.
                  </dd>
                  <dd>
                    <span>③</span>임차인이 계약종료를 원할경우, 만료일전까지
                    소재지가 변경된 사업자등록증 또는
                    폐업사실증명원(휴업사실증명원 제외)를 임대인에게 제공하여야
                    정상적으로 계약이 종료된다.
                  </dd>
                </dl>
                <dl>
                  <dt>제6조 [계약연장] </dt>
                  <dd>
                    계약 종료일 30일까지 별도의 의사표시가 없는 경우, 월
                    임대료에 대해 임차인이 사전 동의한 자동결제수단을 이용하여
                    매월 자동연장된다.
                  </dd>
                </dl>
                <dl>
                  <dt>제7조 [특약사항]</dt>
                  <dd>위에 언급되지 않은 사항은 특약으로 갈음한다.</dd>
                </dl>
                <div className="form_box">
                  <div className="form_row">
                    <div className="form_col">
                      <label>
                        <p>계약자명</p>
                        <div className="input_box">
                          <input
                            type="text"
                            defaultValue={order.repName}
                            readOnly
                          />
                        </div>
                      </label>
                    </div>
                    <div className="form_col">
                      <label>
                        <p>연락처</p>
                        <div className="input_box">
                          <input
                            type="text"
                            defaultValue={order.repPhone}
                            readOnly
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="form_row">
                    <div className="form_col">
                      <label>
                        <p>이메일</p>
                        <div className="input_box">
                          <input
                            type="text"
                            defaultValue={order.email}
                            readOnly
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="form_double">
                  <div className="form_box">
                    <h2>신청인 정보</h2>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>상호명</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={order.companyName}
                              readOnly
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col has_sign">
                        <label>
                          <p>이름</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={order.repName}
                              readOnly
                            />
                          </div>
                        </label>
                        <div
                          className="sign_box"
                          id="signContent"
                          style={{ marginRight: 10 }}
                        >
                          <img src={imgUrl} />

                        </div>
                        <div className="sign_box">
                          {/* <a href="#sign_modal" rel="modal:open">  */}
                          <a
                            ref = {xRef}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              dgRef.current.open();
                            }}
                          >
                            서명하기
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>주민번호/사업자번호</p>
                          <div className="input_box">
                            <input
                              type="text"
                              // defaultValue={${order.civilNum1}-${order.civilNum2}}
                              defaultValue={`${order.civilNum1}-${order.civilNum2} / ${order.bizNum1}-${order.bizNum2}-${order.bizNum3}`}
                              readOnly
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>연락처</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={order.repPhone}
                              readOnly
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>주소</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={`${order.addr1} ${order.addr2}`}
                              readOnly
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="form_box">
                    <h2>임대인 정보</h2>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>상호명</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={lessor.companyName}
                              disabled=""
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>이름</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={lessor.repName}
                              disabled=""
                            />
                          </div>
                        </label>
                        <div className="sign_box sign_1">
                          {stampUrl1 ? <img src={stampUrl1} /> : null}
                        </div>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>사업자번호</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={lessor.bizNum}
                              disabled=""
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>연락처</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={lessor.phone}
                              disabled=""
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="form_row">
                      <div className="form_col">
                        <label>
                          <p>주소</p>
                          <div className="input_box">
                            <input
                              type="text"
                              defaultValue={lessor.addr}
                              disabled=""
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {isSubLease ? (
                  <div className="owner_agree">
                    <h2>소유주 동의</h2>
                    <div className="row">
                      <p>
                        본 전대차 계약은 소유주 <b>"{ownerName}"</b>이 확인/동의 함
                      </p>
                      {stampUrl2 ? <img src={stampUrl2} /> : null}
                    </div>
                  </div>
                ) : null}
                <div className="privacy">
                  <h2>개인정보 수집 및 이용동의</h2>
                  <label>
                    <input
                      type="checkbox"
                      checked={order.privacyYn === "Y"}
                      readOnly
                    />
                    <span>
                      개인정보 수집 및 이용 동의{" "}
                      <a href="#privacy_modal" rel="modal:open">
                        [보기]
                      </a>
                    </span>
                  </label>
                </div>
              </div>
              <div className="special">
                <h3>특약사항</h3>
                <div className="special_cont">
                  <dl>
                    <dt>
                      1. 계약만료 30일 전까지 별도의 계약종료 통보가 없으면
                      자동으로 1개월씩 연장되어 본 계약의 효력이 유지됩니다.
                    </dt>
                  </dl>
                  <dl>
                    <dt>
                      2. 계약서 최초 작성시 계약기간 사용료 선납을 원칙으로 하며
                      이후 미선납시 한달단위 자동결제수단으로 지불한다.
                    </dt>
                  </dl>
                  <dl>
                    <dt>
                      3. .우편물 메일발송서비스 신청시 대리개봉 규정에
                      동의한것으로 간주하며 미동의(미신청)시 우편물 메일발송
                      서비스 제공하지 아니한다.{" "}
                    </dt>
                  </dl>
                  <dl>
                    <dt>
                      4. 우편물 발송서비스 신청유무와 관계없이 우편물 도착후
                      1개월 보관후 폐기한다.
                    </dt>
                  </dl>
                  <dl>
                    <dt>
                      5. 택배관리는 별도요금을 지불한다. 택배물품보관료 : 개당
                      3천원 택배물품은 도착후 1개월간 보관하며 미수령시
                      폐기한다.
                    </dt>
                  </dl>
                  <dl>
                    <dt>
                      6. 임대차 계약만료 후 7일 이내 이전,폐업 자진 미신고시
                      폐업신고에 대해 임차인은 임대인에게 위임한다.
                    </dt>
                  </dl>
                  <dl>
                    <dt>
                      7. 제출된 업종내역과 다른 업종영위시 계약은 해지되면
                      납입되니 임대료는 위약금으로 전환되어 반환되지 아니한다.
                    </dt>
                  </dl>
                </div>
              </div>
              <div className="btn_box">
                <a
                  href="#"
                  className="cancle_btn btn"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/contract1/${order.productCode}`, {
                      replace: true,
                      state: {
                        order: order,
                        pack: {
                          url: "/contract1",
                          data: {
                            order: order,
                          },
                        },
                      },
                    });
                  }}
                >
                  취소
                </a>
                {
                  account?.user?.id ? (
                    <ConfirmDialog
                      btn={
                        <button type="button" className="submit_btn btn" >
                          무결제 등록
                        </button>
                      }
                      content={`관리자 모드로 결제완료로 처리됩니다.`}
                      preHandle={async () => {
                        return prepareSubmit()
                      }}
                      perform={() => {
                        onSubmit(true)
                      }}
                    />

                  ) : (
                    <button type="button" className="submit_btn btn"
                      onClick={() => onSubmit(false)}
                    >
                      결제하기
                    </button>
                  )
                }
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      <div id="sign_modal" className="modal">
        <div className="box">
          <div className="tab_box">
            <nav className="tab_nav">
              <ul>
                <li>
                  <a href="#tab_1">서명/인감 파일 등록</a>
                </li>
                <li>
                  <a href="#tab_2" id="tab2Link">
                    서명 그리기
                  </a>
                </li>
              </ul>
            </nav>
            <div className="tabs_content">
              <div id="tab_1" className="tab_1 tab_cont">
                <label className="custom_file">
                  <span className="filename" />
                  <input
                    type="file"
                    className="input_file"
                    name="file"
                    id="signImgInput"
                  />
                  <button type="button" className="upload_btn">
                    파일 선택
                  </button>
                </label>
                <span>*png, jpg 등 이미지 파일을 등록 가능 합니다.</span>
                <div className="btn_box">
                  <button
                    type="button"
                    id="imgUpBtn"
                    className="submit_btn btn"
                    onClick={(e) => {
                    }}
                  >
                    서명 등록하기
                  </button>
                </div>
              </div>
              <div id="tab_2" className="tab_2 tab_cont">
                <div className="sign_box draw_sign">
                  <div className="sign_canvas">
                    <canvas id="drawCanvas" />
                  </div>
                  <div className="btn_box">
                    <button
                      type="button"
                      className="cancle_btn btn"
                      id="drawSignCan"
                    >
                      초기화
                    </button>
                    <button
                      type="button"
                      className="submit_btn btn"
                      id="drawSignBtn"
                    >
                      서명 등록하기
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contract2;
